import { createSlice } from "@reduxjs/toolkit";
import { getLeaves } from "services/leaves/leaves";

const initialState = {
    leaves : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}
export const getLeavesSlice = createSlice({
    name: 'get leaves',
    initialState,
    extraReducers: {
        [getLeaves.pending]: (state) => {
            state.leaves.isLoading = true;
        },
        [getLeaves.fulfilled]: (state, { payload }) => {
            state.leaves.isLoading = false;
            state.leaves.isSuccess = true;
            state.leaves.data = payload;
        },
        [getLeaves.rejected]: (state, { payload }) => {
            state.leaves.isLoading = false;
            state.leaves.isSuccess = false;
            state.leaves.errorMessage = payload
        }
    }
})
export default getLeavesSlice.reducer;